import type React from 'react'
import Skeleton from 'react-loading-skeleton'
import * as S from './Minisearch.styles'

const CategoryTileSkeleton: React.FC = () => {
  return (
    <div style={{ minWidth: '200px', flexShrink: 0 }}>
      <div style={{ aspectRatio: '4/5', marginBottom: '1rem' }}>
        <Skeleton
          style={{ width: '100%', height: '100%', aspectRatio: '4/5' }}
        />
      </div>
      <div style={{ textAlign: 'center' }}>
        <Skeleton width="80%" height="1.6rem" />
      </div>
    </div>
  )
}

export const CollectionSearchResultsSkeleton: React.FC = () => {
  return (
    <S.SuggestionsContainer>
      <h2>
        <Skeleton width="180px" height="2rem" />
      </h2>
      <S.HorizontalList
        role="region"
        tabIndex={0}
        aria-label="Suggested categories loading"
      >
        {Array.from({ length: 4 }).map((_, index) => (
          <CategoryTileSkeleton key={index} />
        ))}
      </S.HorizontalList>
    </S.SuggestionsContainer>
  )
}
